import axios from 'axios';

/**
 * 
 * @param {{
 *  page: number,
 *  limit: number,
 *  filters: Filters,
 * }} pagination 
 * @returns 
 */
export async function getIssues(pagination) {
    return axios({
        method: 'post',
        url: '/api/v2/issues/list',
        data: pagination,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export async function getIssue(id) {
    return axios({
        method: 'get',
        url: `/api/v2/issues/${id}`,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

/**
 * 
 * @param {string} id 
 * @param {Status } status 
 */
export async function updateIssueStatus(id, status) {
    return axios({
        method: 'put',
        url: `/api/v2/issues/${id}/status`,
        data: { status },
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

/**
 * 
 * @param {string} id 
 * @param {Comment} data 
 */
export async function addIssueComment(id, data) {
    return axios({
        method: 'post',
        url: `/api/v2/issues/${id}/comment`,
        data,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

/**
 * 
 * @param {string} id 
 * @param {string} commentId
 * @param {Comment} data 
 */
export async function updateIssueComment(id, commentId, data) {
    return axios({
        method: 'put',
        url: `/api/v2/issues/${id}/comment/${commentId}`,
        data,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

/**
 * 
 * @param {string} id 
 * @param {string} commentId 
 */
export async function deleteIssueComment(id, commentId) {
    return axios({
        method: 'delete',
        url: `/api/v2/issues/${id}/comment/${commentId}`,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

/**
 * @typedef {Object} Filters
 * @property {string} [company]
 * @property {Date} [dateFrom]
 * @property {Date} [dateTo]
 */

/**
 * @typedef {'new' | 'inProgress' | 'confirmed' | 'fixed' | 'notBug'} Status
 */

/**
 * @typedef {Object} Comment
 * @property {string} text
 */



// WEBPACK FOOTER //
// ./app/services/issues.js